
import React from 'react';
import { Link } from 'react-router-dom';
import './style.css';

const Footer = () => {
  return (
    <footer className="footer">
<div className="container">
<div className="h1 logo">
          <Link to="/"><div className="gonzalogo"><img alt="Gonzalo Logo" src="/assets/images/gonzalogo.png" /></div>Gonza<span>.</span></Link>
</div>
<p className="copyright">
        © 2023 <a href="https://gonzalo.desalterain.com.ar">Gonzalo de Salterain</a>. All rights reserved
      </p>
</div>
</footer>
  );
}

export default Footer;
